import gql from 'graphql-tag';

const DAILY_FRAGMENT = gql`
	fragment serviceRunsDaily on ServiceRun {
		id
		planned
		cashReconciliationStatus
		order
		restockType
		ignoreSitePermissions
		brief
		warehouse {
			id
			name
		}
		returnWarehouse {
			id
			name
		}
		route {
			id
			name
		}

		driver {
			id
			username
			firstname
			lastname
			destroyed
			userSitePermissions {
				id
				expiresAt
				sitePermission {
					id
					policy
				}
			}
		}
		vehicle {
			id
			name
			lastCoordinates
		}

		pickLists {
			id
			isAnyItemPicked
		}
			serviceDockets {
				id
				status
				date
				totalPickItemsQuantity
				tub
				tubWeightSummary
				salesSinceLastRestock
				manualRestock
				manualRestockComment
				dune
			expiryProductsCount
			manualRestockApprovedBy {
				id
				firstname
				lastname
			}
			isRestocked
			startedProcessing
			inventoryCheck
			replacementReviewRequired
			replacementReviewReason
			inventoryPicked
			inventoryPartiallyPicked
			machineServiceType
			machineRestockType
			vendsSinceLastRestock

			someTicketsNotResolved
			ticketsResolved
			driverTicketCount

			collectCash
			cashCollected

			requirePhoto
			photoTaken

			inventoryChanges
			inventoryChangesPercentage
			inventoryChangesSelections
			order
			pickList {
				id
				calculatedAt
				isAnyItemPicked
				pickers {
					id
					firstname
					lastname
					username
					destroyed
				}
			}

			serviceRun {
				id
			}

			place {
				id
				name
				destroyed
			}
			location {
				id
				name
				noteCount
				destroyed
				client {
					id
					name
				}
			}
			machine {
				id
				type
				assetId
				brand
				destroyed
				place {
					id
					name
					destroyed
					serviceGroup {
						id
						name
						location {
							id
							name
						}
					}
				}
				location {
					id
					name
					noteCount
					destroyed
					client {
						id
						name
					}
				}
				vendouts
				salesSinceLastRestock
				cashSinceLastCollection
				planogram {
					id
				}
				ingredientPlanogram {
					id
				}
				noteCount
				openTicketCount
				openIssueTicketCount
				openMaintenanceTicketCount
				openJobTicketCount

				isOffline
				usesIngredients
				overridePredictiveGlobalSettings
				overrideUsePredictivePickLists

				planogramItemNextExpiryDate
				requiredSitePermissions {
					id
					name
					durationInDays
					daysOfWeek
					policy
					clients {
						id
					}
					locations {
						id
					}
					places {
						id
					}
					legacyMachines {
						id
					}
				}
				siteBookingNotices {
					id
					name
					bookingProcess
					clients {
						id
					}
					locations {
						id
					}
					places {
						id
					}
				}
			}
		}
	}
`;
export default DAILY_FRAGMENT;
